'use strict';

/**
 * Default setting index view
 *
 * @category   View
 * @module     dashboard
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('modules/settings/templates/layout/index.hbs');

var ImportLayout = LayoutView.extend({
    template: template,
});

module.exports = ImportLayout;